"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpMethod = exports.ErrorCode = void 0;
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["Technical"] = -1] = "Technical";
    ErrorCode[ErrorCode["Cancel"] = 0] = "Cancel";
    ErrorCode[ErrorCode["Unauthorized"] = 401] = "Unauthorized";
    ErrorCode[ErrorCode["BadRequest"] = 400] = "BadRequest";
    ErrorCode[ErrorCode["ForbiddenAccess"] = 403] = "ForbiddenAccess";
    ErrorCode[ErrorCode["ServerIssue"] = 500] = "ServerIssue";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Get"] = "get";
    HttpMethod["Post"] = "post";
    HttpMethod["Put"] = "put";
    HttpMethod["Delete"] = "delete";
    HttpMethod["Patch"] = "patch";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
